module.exports = __webpack_public_path__ + "img/binary-slash.070e421f.svg";